import React, { useEffect, useState } from 'react';

import { TEMPLATES_GALLERY_ENTRY } from '@utils/constants';
import { templatesPath } from './useRouter';

export const useTemplateEntry = () => {
  const [entry, setEntry] = useState<string | null>();

  useEffect(() => {
    const referrer = document?.referrer;
    const urlParams = new URL(window.location.href).searchParams;

    const isFromTemplatesGallery = referrer?.includes(templatesPath);
    const entryFromUrl = urlParams.get('entry');

    let entryType: string | null = null;

    if (isFromTemplatesGallery) {
      entryType = TEMPLATES_GALLERY_ENTRY;
    } else if (entryFromUrl) {
      entryType = entryFromUrl;
    }

    setEntry(entryType);
  }, []);

  return {
    entry,
  };
};
